import DeviceDashboardPage from './DeviceDashboardPage.js';
import DevicePage from './DevicePage.js';
import DeviceHistoryPage from './DeviceHistoryPage.js';
import DeviceSummaryPage from './DeviceSummaryPage.js';
import AccessWindowsPage from './AccessWindowsPage.js';

export async function registerDevicePages(app) {
    app.registerPage('group/device/dashboard', DeviceDashboardPage);
    app.registerPage('group/devices', DevicePage);
    app.registerPage('group/report/summary', DeviceSummaryPage);
    app.registerPage('group/device/history', DeviceHistoryPage);
    app.registerPage('group/access', AccessWindowsPage);

    // ── Devices platform sidebar ──────────────────────────────────────────────
    app.sidebar.addMenu('group_devices', {
        name: 'group_devices',
        groupKind: 'any',
        className: 'sidebar sidebar-dark',
        items: [
            {
                icon: 'bi-speedometer2',
                text: 'Dashboard',
                route: '?page=group/device/dashboard',
            },
            {
                icon: 'bi-lock-fill',
                text: 'Devices',
                route: '?page=group/devices',
                permissions: ['manage_cam_devices', 'manage_group', 'manage_groups'],
            },
            {
                icon: 'bi-key-fill',
                text: 'Access Windows',
                route: '?page=group/access',
                permissions: ['manage_cam_devices', 'manage_group', 'manage_groups'],
            },
            {
                icon: 'bi-cpu',
                text: 'Firmware',
                id: 'nav-firmware',
                permissions: ['manage_firmware', 'manage_cam_devices', 'view_cam_devices', 'manage_group', 'manage_groups'],
                children: [
                    {
                        icon: 'bi-sliders',
                        text: 'Assignments',
                        route: '?page=group/firmware',
                        permissions: ['manage_firmware', 'manage_cam_devices', 'view_cam_devices', 'manage_group', 'manage_groups'],
                    },
                    {
                        icon: 'bi-activity',
                        text: 'OTA Activity',
                        route: '?page=group/firmware/updates',
                        permissions: ['manage_firmware', 'manage_cam_devices', 'view_cam_devices', 'manage_group', 'manage_groups'],
                    },
                ],
            },
            {
                icon: 'bi-graph-up',
                text: 'Reports',
                id: 'nav-reports-devices',
                permissions: ['view_metrics', 'manage_cam_devices', 'manage_group', 'manage_groups'],
                children: [
                    {
                        icon: 'bi-bar-chart-line-fill',
                        text: 'Summary Report',
                        route: '?page=group/report/summary',
                        permissions: ['view_metrics', 'manage_group', 'manage_groups'],
                    },
                    {
                        icon: 'bi-clock-fill',
                        text: 'Activity Report',
                        route: '?page=group/device/history',
                        permissions: ['view_metrics', 'manage_group', 'manage_groups'],
                    },
                ],
            },
            {
                icon: 'bi-gear-fill',
                text: 'Settings',
                id: 'nav-settings',
                permissions: ['billing', 'manage_group', 'manage_groups'],
                children: [
                    {
                        icon: 'bi-people-fill',
                        text: 'Members',
                        route: '?page=group/members',
                        permissions: ['manage_group', 'manage_groups'],
                    },
                    {
                        icon: 'bi-gear-fill',
                        text: 'General Settings',
                        route: '?page=group/settings',
                        permissions: ['manage_group', 'manage_groups'],
                    },
                    {
                        icon: 'bi-files',
                        text: 'Licenses',
                        route: '?page=group/billing_package',
                        permissions: ['billing', 'manage_group', 'manage_groups'],
                    },
                ],
            },
        ],
        footer: `
        <div class="text-center py-3">
        <img style='width:150px;' src='/imgs/mojo_ware_logo.png' alt='MojoWare Logo' class='footer-logo'>
        <div class="text-center">${app.version}</div>
        </div>
        `
    });
}
